import {$} from '../util/jq';
import changePageClass from './_changePageClass';
import initProducts from './_initProducts';
import initAnswerMods from "./_initAnswerMods";

const initPrintButton = () => {
  $('.actions').find('.print').click(function () {
    window.print();
  });
};

export default function detailsPage() {
  changePageClass('details');
  $('html').removeClass('wf-loading');
  initProducts();
  initPrintButton();
  initAnswerMods();
}



// WEBPACK FOOTER //
// ./src/main/js/pages/detailsPage.js